import { useState } from 'react';
import { Card, Typography } from 'antd';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { useSimulation } from '../../context/SimulationContext';
import './ScenarioPanel.scss';

function ScenarioPanel() {
  const { narrativeContext } = useSimulation();
  const [collapsed, setCollapsed] = useState(false);

  if (!narrativeContext) return null;

  return (
    <Card
      title="Scenario"
      className="scenario-panel"
      size="small"
      extra={
        <span
          className="collapse-toggle"
          onClick={() => setCollapsed(!collapsed)}
        >
          {collapsed ? <DownOutlined /> : <UpOutlined />}
        </span>
      }
    >
      {!collapsed && (
        <Typography.Paragraph className="scenario-text">
          {narrativeContext}
        </Typography.Paragraph>
      )}
    </Card>
  );
}

export default ScenarioPanel;
